<div class="content-block">
  <div class="row">
    <div class="col">
      @if (content.imageUrl) {
        <img class="img-fluid" alt="" [src]="content.imageUrl" />
      }
    </div>
  </div>
  @if (content.icon) {
    <span class="fa fa-3x icon" [ngClass]="content.icon"></span>
  }
  @if (content.header) {
    <h4 class="header" [innerHTML]="header"></h4>
  }
  <div style="width:100%" [innerHTML]="contentBlock"></div>
</div>